var map = {
	"./de/triangleIcon.png": "m6gr",
	"./en/triangleIcon.png": "cbcw",
	"./es/triangleIcon.png": "POBC",
	"./fr/triangleIcon.png": "6+h5",
	"./ja/triangleIcon.png": "qIFV",
	"./ko/triangleIcon.png": "/den",
	"./pt/triangleIcon.png": "Bssw",
	"./ru/triangleIcon.png": "C912",
	"./tc/triangleIcon.png": "T6ss",
	"./th/triangleIcon.png": "M+eh"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WP1+";